// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cloud_agent_embed.proto (package cloud_protocol, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_logger_options } from "./logger/options_pb";
/**
 * Describes the file cloud_agent_embed.proto.
 */
export const file_cloud_agent_embed = /*@__PURE__*/ fileDesc("ChdjbG91ZF9hZ2VudF9lbWJlZC5wcm90bxIOY2xvdWRfcHJvdG9jb2wi2wEKCkFnZW50RW1iZWQSJwoOY2xvdWRfYWdlbnRfaWQYASABKAlCD7pQDGNsb3VkQWdlbnRJRBIgCgpwcm9qZWN0X2lkGAIgASgJQgy6UAlwcm9qZWN0SUQSDwoHZW5hYmxlZBgDIAEoCBIXCg9hbGxvd2VkX29yaWdpbnMYBCADKAkSMAoGY29uZmlnGAUgASgLMiAuY2xvdWRfcHJvdG9jb2wuQWdlbnRFbWJlZENvbmZpZxISCgpjcmVhdGVkX2F0GAYgASgDEhIKCnVwZGF0ZWRfYXQYByABKAMiiQIKEEFnZW50RW1iZWRDb25maWcSDQoFY29sb3IYASABKAkSDAoEbG9nbxgCIAEoCRIWCg5saXN0ZW5pbmdfdGV4dBgDIAEoCRI1CgV0aGVtZRgEIAEoDjImLmNsb3VkX3Byb3RvY29sLkFnZW50RW1iZWRDb25maWcuVGhlbWUSFQoNc3VwcG9ydHNfY2hhdBgFIAEoCBIWCg5zdXBwb3J0c192aWRlbxgGIAEoCBIcChRzdXBwb3J0c19zY3JlZW5zaGFyZRgHIAEoCBISCgphZ2VudF9uYW1lGAggASgJIigKBVRoZW1lEgoKBlNZU1RFTRAAEgkKBUxJR0hUEAESCAoEREFSSxACIs0BCg1HZXRBZ2VudEVtYmVkGlQKB1JlcXVlc3QSJwoOY2xvdWRfYWdlbnRfaWQYASABKAlCD7pQDGNsb3VkQWdlbnRJRBIgCgpwcm9qZWN0X2lkGAIgASgJQgy6UAlwcm9qZWN0SUQaZgoIUmVzcG9uc2USDwoHZW5hYmxlZBgBIAEoCBIXCg9hbGxvd2VkX29yaWdpbnMYAiADKAkSMAoGY29uZmlnGAMgASgLMiAuY2xvdWRfcHJvdG9jb2wuQWdlbnRFbWJlZENvbmZpZyLFAQoQVXBkYXRlQWdlbnRFbWJlZBqwAQoHUmVxdWVzdBInCg5jbG91ZF9hZ2VudF9pZBgBIAEoCUIPulAMY2xvdWRBZ2VudElEEiAKCnByb2plY3RfaWQYAiABKAlCDLpQCXByb2plY3RJRBIPCgdlbmFibGVkGAMgASgIEhcKD2FsbG93ZWRfb3JpZ2lucxgEIAMoCRIwCgZjb25maWcYBSABKAsyIC5jbG91ZF9wcm90b2NvbC5BZ2VudEVtYmVkQ29uZmlnMs0BChFBZ2VudEVtYmVkU2VydmljZRJgCg1HZXRBZ2VudEVtYmVkEiUuY2xvdWRfcHJvdG9jb2wuR2V0QWdlbnRFbWJlZC5SZXF1ZXN0GiYuY2xvdWRfcHJvdG9jb2wuR2V0QWdlbnRFbWJlZC5SZXNwb25zZSIAElYKEFVwZGF0ZUFnZW50RW1iZWQSKC5jbG91ZF9wcm90b2NvbC5VcGRhdGVBZ2VudEVtYmVkLlJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkiAEIrWilnaXRodWIuY29tL2xpdmVraXQvYmFja2VuZC1jb21tb24vYmFja2VuZGIGcHJvdG8z", [file_google_protobuf_empty, file_logger_options]);
/**
 * Describes the message cloud_protocol.AgentEmbed.
 * Use `create(AgentEmbedSchema)` to create a new message.
 */
export const AgentEmbedSchema = /*@__PURE__*/ messageDesc(file_cloud_agent_embed, 0);
/**
 * Describes the message cloud_protocol.AgentEmbedConfig.
 * Use `create(AgentEmbedConfigSchema)` to create a new message.
 */
export const AgentEmbedConfigSchema = /*@__PURE__*/ messageDesc(file_cloud_agent_embed, 1);
/**
 * @generated from enum cloud_protocol.AgentEmbedConfig.Theme
 */
export var AgentEmbedConfig_Theme;
(function (AgentEmbedConfig_Theme) {
    /**
     * @generated from enum value: SYSTEM = 0;
     */
    AgentEmbedConfig_Theme[AgentEmbedConfig_Theme["SYSTEM"] = 0] = "SYSTEM";
    /**
     * @generated from enum value: LIGHT = 1;
     */
    AgentEmbedConfig_Theme[AgentEmbedConfig_Theme["LIGHT"] = 1] = "LIGHT";
    /**
     * @generated from enum value: DARK = 2;
     */
    AgentEmbedConfig_Theme[AgentEmbedConfig_Theme["DARK"] = 2] = "DARK";
})(AgentEmbedConfig_Theme || (AgentEmbedConfig_Theme = {}));
/**
 * Describes the enum cloud_protocol.AgentEmbedConfig.Theme.
 */
export const AgentEmbedConfig_ThemeSchema = /*@__PURE__*/ enumDesc(file_cloud_agent_embed, 1, 0);
/**
 * Describes the message cloud_protocol.GetAgentEmbed.
 * Use `create(GetAgentEmbedSchema)` to create a new message.
 */
export const GetAgentEmbedSchema = /*@__PURE__*/ messageDesc(file_cloud_agent_embed, 2);
/**
 * Describes the message cloud_protocol.GetAgentEmbed.Request.
 * Use `create(GetAgentEmbed_RequestSchema)` to create a new message.
 */
export const GetAgentEmbed_RequestSchema = /*@__PURE__*/ messageDesc(file_cloud_agent_embed, 2, 0);
/**
 * Describes the message cloud_protocol.GetAgentEmbed.Response.
 * Use `create(GetAgentEmbed_ResponseSchema)` to create a new message.
 */
export const GetAgentEmbed_ResponseSchema = /*@__PURE__*/ messageDesc(file_cloud_agent_embed, 2, 1);
/**
 * Describes the message cloud_protocol.UpdateAgentEmbed.
 * Use `create(UpdateAgentEmbedSchema)` to create a new message.
 */
export const UpdateAgentEmbedSchema = /*@__PURE__*/ messageDesc(file_cloud_agent_embed, 3);
/**
 * Describes the message cloud_protocol.UpdateAgentEmbed.Request.
 * Use `create(UpdateAgentEmbed_RequestSchema)` to create a new message.
 */
export const UpdateAgentEmbed_RequestSchema = /*@__PURE__*/ messageDesc(file_cloud_agent_embed, 3, 0);
/**
 * @generated from service cloud_protocol.AgentEmbedService
 */
export const AgentEmbedService = /*@__PURE__*/ serviceDesc(file_cloud_agent_embed, 0);
